import React, { useState } from 'react'
import { Field } from 'redux-form'
import { renderSelectField } from '../../Forms/fieldRenderers'
import { Row, Col, Form } from 'react-bootstrap'
import { Grid, Tooltip, TextField } from '@material-ui/core'

import Input from '@material-ui/core/Input'
import MenuItem from '@material-ui/core/MenuItem'
import FormControl from '@material-ui/core/FormControl'
import ListItemText from '@material-ui/core/ListItemText'
import Select from '@material-ui/core/Select'
import Checkbox from '@material-ui/core/Checkbox'
import Chip from '@material-ui/core/Chip'
import Fab from '@material-ui/core/Fab'
import AddIcon from '@material-ui/icons/Add'
import DeleteForeverSharpIcon from '@material-ui/icons/DeleteForeverSharp'

import {
  EntityAutocomplete,
  CerealDropdown
} from '../../Forms/SharedComponents/containers'
import { parseEntityId,
  parseEntityName
} from '../../../models/entity'

import InputLabel from '@material-ui/core/InputLabel'
import {
  required
} from '../../Forms/fieldValidators'

import Autocomplete from '@material-ui/lab/Autocomplete'
import moment from 'moment'

function CamposCaratula (props) {
  const [exportadorSeleccionado] = useState([])

  const handleAceitero = () => {
    const { 
      handleBuqueAceitero
    } = props
    handleBuqueAceitero()
  }
  
  const renderGiros = () => {
    const {
      giros
    } = props

    const options = giros.map((giro, index) => {
      return (
        <option
          value={giro.nombreCorto}
          key={index + 1}
        >
          {giro.nombre}
        </option>
      )
    })
    options.unshift((<option value={null} key={0} />))
    return options
  }

  const handleChange = (event) => {
    const {
      handleSacarExportador
    } = props
    handleSacarExportador(event.target.value)
    // setExportadorSeleccionado(() => exportadorSeleccionado.filter(exp => exp != event.target.value))
    // updateListaExportadoresSeleccionados(event.target.value)
  }

  const handleAgregaExportador = () => {
    const {
      handleAgregarExportador
    } = props
    // setExportadorSeleccionado(event.target.value)
    handleAgregarExportador()
  }

  const ITEM_HEIGHT = 48
  const ITEM_PADDING_TOP = 8
  const MenuProps = {
    PaperProps: {
      style: {
        maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
        width: 350
      }
    }
  }

  const {
    fechaArribo,
    fechaZarpada,
    selectedGiro,
    isRequesting,
    onSelect,
    changeArribo,
    changeZarpada,
    changeBuque,
    buques,
    buque,
    onlyView,
    caratulaExportador,
    buqueAceitero,
    cereal
  } = props

  console.log('giro recibido', selectedGiro)
  console.log('buque recibido', buque)
  console.log('cereal recibido', cereal)
  return (
    <div>
      <fieldset disabled={onlyView}>
        <Row>
          <Col md={6}>
            <InputLabel id='buque-select' style={{ fontSize: '14px', color: '#000' }}>Nombre del Buque *</InputLabel>
            {/* <EntityAutocomplete
                name='buque'
                labelId='buque-select'
                label=''
                entity='buque'
                placeholder=''
                validate={[required]}
              /> */}
            <Autocomplete
              autoHighlight
              id='buque-select'
              name='buque'
              size='small'
              options={buques}
              //disabled={onlyView}
              defaultValue={buque || null}
              getOptionLabel={(option) => `${option.nombre}`}
              onChange={(event, value) => changeBuque(value)}
              renderInput={(params) => <TextField {...params} variant='outlined' />}
            />
          </Col>
          <Col md={6}>
            {/* <InputLabel id='agencia-select'>Agencia Marítima</InputLabel> */}
            <EntityAutocomplete
              name='agencia'
              labelId='agencia-select'
              label='Agencia Marítima'
              entity='agencia_maritima'
              placeholder=''
              validate={[required]}
            />
          </Col>
          {/* <Col md={4}>
              <InputLabel id='nro-viaje'>Nº de Viaje (ID Viaje)</InputLabel>
              <Field
                name='nroViaje'
                type='text'
                label='Nº de Viaje (ID Viaje)'
                component={renderTextField}
                validate={[required, maxLength16]}
              />
            </Col> */}
        </Row>
        <Row>
          <Grid container justify='space-around'>
            <Col md={4}>
              {/* <InputLabel id='giro-select'>Giro</InputLabel> */}
              <Field
                onChange={onSelect}
                name='giro'
                label='Giro *'
                autoFocus={false}
                component={renderSelectField}
                value={selectedGiro}
                validate={[required]}
                disabled={onlyView}
              >
                {isRequesting ? null : renderGiros()}
              </Field>
            </Col>
            <Col md={4}>
              <TextField
                id='datetime-local'
                label='Arribo *'
                name='fechaArribo'
                type='datetime-local'
                disabled={onlyView}
                defaultValue={moment(fechaArribo).format('YYYY-MM-DD[T]HH:mm') || moment().format('YYYY-MM-DD[T]HH:mm')}
                onChange={(e) => { changeArribo(e) }}
                helperText='El arribo deberá ser entre 5 y 96 hs posteriores al registro en Aduana'
                InputLabelProps={{
                  shrink: true
                }}
              />
            </Col>
            <Col md={4}>
              <TextField
                id='datetime-local'
                label='Zarpada *'
                name='fechaZarpada'
                type='datetime-local'
                ampm={false}
                disabled={onlyView}
                defaultValue={moment(fechaZarpada).format('YYYY-MM-DD[T]HH:mm') || moment().format('YYYY-MM-DD[T]HH:mm')}
                onChange={(e) => { changeZarpada(e) }}
                helperText='Fecha/Hora prevista de zarpada'
                InputLabelProps={{
                  shrink: true
                }}
              />
            </Col>
          </Grid>
        </Row>
        <Row>
          <Grid container justify='justify-start' alignItems='center'>
            <Col md={5}>
              <EntityAutocomplete
                name='exportador'
                label='Destinatario'
                entity='exportador'
                placeholder='Exportador - 19999999991'
                value={''}
              />
            </Col>
            <Col md={1}>
              {/* <Tooltip title={'Agregar Destinatario'}>
                  <Button
                    onClick={handleAgregarExportador}
                    color='primary'
                  >+
                  </Button>
                </Tooltip> */}
              <Tooltip title={'Agregar Destinatario'}>
                <Fab color='primary' aria-label='Agregar Destinatario' size='small'
                  onClick={handleAgregaExportador} disabled={onlyView}
                >
                  <AddIcon />
                </Fab>
              </Tooltip>
            </Col>
            <Col md={2}>
              <Form.Check
                type='checkbox'
                id='aceitero'
                label='Buque Aceitero'
                custom
                checked={buqueAceitero}
                disabled={onlyView}
                onChange={() => handleAceitero()}
              />
            </Col>
            <Col md={4}>
              <CerealDropdown disabled={buqueAceitero || onlyView} />
            </Col>
          </Grid>
        </Row>
        <Row>
          {caratulaExportador && caratulaExportador.length > 0 &&  
            <FormControl style={{ marginLeft: '2%', minWidth: 300, maxWidth: 500 }}>
              <InputLabel id='seleccion-label'>Destinatarios seleccionados</InputLabel>
              <Select
                labelId='seleccion-label'
                id='exportadoresSeleccionados'
                multiple
                value={exportadorSeleccionado}
                onChange={handleChange}
                input={<Input />}
                disabled={onlyView}
                renderValue={
                  (selected) => selected.map((seleccionado) =>
                    <Chip
                      display='flex'
                      flexwrap='wrap'
                      color='primary'
                      variant='outlined'
                      key={parseEntityId(seleccionado)}
                      label={parseEntityName(seleccionado)}
                    />
                  )}
                MenuProps={MenuProps}
              >
                {caratulaExportador.map((exportador) => (
                  <MenuItem key={parseEntityId(exportador)} value={exportador}>
                    <Tooltip title={'Eliminar Destinatario'}>
                      <Checkbox checked />
                    </Tooltip>
                    <ListItemText primary={parseEntityName(exportador)} secondary={parseEntityId(exportador)} />
                    <Tooltip title={'Eliminar Destinatario'}>
                      <DeleteForeverSharpIcon />
                    </Tooltip>
                  </MenuItem>
                ))}
              </Select>
            </FormControl>}
        </Row>
        <Row>
          <Grid container justify='flex-end'>
            <p style={{ paddingRight: '15px' }}>(*) Campo requerido obligatorio</p>
          </Grid>
        </Row>
      </fieldset>
    </div>
  )
}

export default CamposCaratula
